import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const AddTransitionModal = ({
  open,
  onClose,
  onSubmit,
  items = [],
  allSops = [],
  loading = false,
}) => {
  const [fromId, setFromId] = useState("");
  const [toId, setToId] = useState("");
  const [outcomeKey, setOutcomeKey] = useState("");
  const [label, setLabel] = useState("");
  const [isDefault, setIsDefault] = useState(false);

  useEffect(() => {
    if (!open) {
      setFromId("");
      setToId("");
      setOutcomeKey("");
      setLabel("");
      setIsDefault(false);
    }
  }, [open]);

  const handleSubmit = () => {
    if (!fromId || !toId) return;

    onSubmit({
      fromPlaybookItemId: fromId,
      toPlaybookItemId: toId,
      outcomeKey: outcomeKey.trim() || null,
      label: label.trim() || null,
      isDefault,
    });
  };

 const getItemLabel = (item) => {
  const seq = item.sequence ? parseInt(item.sequence, 10) / 1024 : "-";
  const sop = allSops.find((s) => s.id === item.sopId);
  const title = sop?.title || "Unknown SOP";
  return `${seq}. ${title}`;
};

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Transition</DialogTitle>

      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>From</InputLabel>
          <Select
            value={fromId}
            label="From"
            onChange={(e) => setFromId(e.target.value)}
          >
            {items.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {getItemLabel(item)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>To</InputLabel>
          <Select
            value={toId}
            label="To"
            onChange={(e) => setToId(e.target.value)}
          >
            {items
              .filter((item) => item.id !== fromId)
              .map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {getItemLabel(item)}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Outcome Key"
          value={outcomeKey}
          onChange={(e) => setOutcomeKey(e.target.value)}
          sx={{ mt: 2 }}
        />

        <TextField
          fullWidth
          label="Label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          sx={{ mt: 2 }}
        />

        <FormControlLabel
          sx={{ mt: 1 }}
          control={
            <Checkbox
              checked={isDefault}
              onChange={(e) => setIsDefault(e.target.checked)}
            />
          }
          label="Default transition"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="secondary"
          disabled={!fromId || !toId || loading}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTransitionModal;